module.exports = __webpack_public_path__ + "static/media/apple_logo.e68ef2b4.svg";